import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import { albumCover } from "constants/placeholderAlbumCover";
import Typography from "components/typography";
import LinkText from "components/typography/linkText";
import PrimaryButton from "components/buttons/primary-button";
import { useNavigate } from "react-router-dom";
import { RatedFanPageItem } from "types/ratedfansData";
import Toast from "components/toast";

const MusicView = ({ data }: { data?: RatedFanPageItem[] }) => {
  const MusicItem = ({
    id,
    slug,
    pageUrl,
    releaseTitle,
    songTitle,
    artistName,
    isPublished,
    isPresaveEnabled,
    coverArtPath,
    totalLinks
  }: RatedFanPageItem) => {
    const navigate = useNavigate();

    const handleCopy = async () => {
      try {
        await navigator.clipboard.writeText(
          `${window.location.origin}/${slug}`
        );
        Toast({ type: "success", message: "Copied to clipboard" });
      } catch (error) {
        Toast({ error: "Failed to copy link" });
      }
    };
    return (
      <ItemContainer>
        <CoverImage src={coverArtPath} alt="coverImage" />
        <ItemTextContainer>
          <FlexContainer>
            <Typography size="2xl" weight="bold" mr="1.2" m_size="lg">
              {releaseTitle}
            </Typography>

            <PrimaryButton
              fitContent
              m_iconButton={true}
              variant="text"
              textColor={Colors.grey400}
              onClick={() => {
                navigate(`/overview/rated-fans/customize-link?slug=${slug}`);
              }}
              text="Customize"
              iconPosition="left"
              iconSize="1.4"
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  height="100%"
                  viewBox="0 0 14 15"
                  fill="none"
                >
                  <path
                    d="M8.64602 4.51871L9.06308 4.10161C9.75414 3.41055 10.8746 3.41055 11.5657 4.10161C12.2567 4.79268 12.2567 5.91312 11.5657 6.60419L11.1486 7.02128M8.64602 4.51871C8.64602 4.51871 8.69813 5.40504 9.48018 6.18709C10.2622 6.96914 11.1486 7.02128 11.1486 7.02128M8.64602 4.51871L4.81145 8.35326C4.55173 8.613 4.42187 8.74283 4.31019 8.88602C4.17844 9.05494 4.0655 9.23769 3.97334 9.43105C3.89521 9.59499 3.83714 9.76923 3.72098 10.1177L3.2288 11.5942M11.1486 7.02128L7.31402 10.8558C7.05428 11.1155 6.92446 11.2454 6.78127 11.3571C6.61235 11.4889 6.42959 11.6018 6.23622 11.694C6.07229 11.7721 5.89806 11.8301 5.54961 11.9463L4.07305 12.4385M3.2288 11.5942L3.10849 11.9552C3.05133 12.1266 3.09595 12.3157 3.22377 12.4435C3.35158 12.5713 3.54063 12.616 3.71211 12.5588L4.07305 12.4385M3.2288 11.5942L4.07305 12.4385"
                    stroke="#CDCDCD"
                    stroke-width="0.787499"
                  />
                </svg>
              }
            />
          </FlexContainer>
          <FlexContainer>
            <LinkText
              text={`${window.location.origin}/${slug}`}
              to={`${window.location.origin}/${slug}`}
              color={Colors.grey500}
              m_size="xs"
            />
            <CopyButton onClick={handleCopy}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 10 11"
                fill="none"
              >
                <path
                  d="M2.5 5.08331C2.5 3.9048 2.5 3.31555 2.86612 2.94943C3.23223 2.58331 3.82149 2.58331 5 2.58331H6.25C7.4285 2.58331 8.01775 2.58331 8.38387 2.94943C8.75 3.31555 8.75 3.9048 8.75 5.08331V7.16665C8.75 8.34515 8.75 8.9344 8.38387 9.30052C8.01775 9.66665 7.4285 9.66665 6.25 9.66665H5C3.82149 9.66665 3.23223 9.66665 2.86612 9.30052C2.5 8.9344 2.5 8.34515 2.5 7.16665V5.08331Z"
                  stroke="#CDCDCD"
                  stroke-width="0.625"
                />
                <path
                  d="M2.5 8.41665C1.80965 8.41665 1.25 7.85702 1.25 7.16665V4.66665C1.25 3.0953 1.25 2.30963 1.73815 1.82147C2.22631 1.33331 3.01198 1.33331 4.58333 1.33331H6.25C6.94037 1.33331 7.5 1.89296 7.5 2.58331"
                  stroke="#CDCDCD"
                  stroke-width="0.625"
                />
              </svg>
            </CopyButton>
          </FlexContainer>
          {/* <Typography size="s" m_size="xs" color={Colors.grey500}>
            {0} Views
          </Typography> */}
        </ItemTextContainer>
        <LinkBtn>
          <PrimaryButton
            variant="p-fade"
            text="View Pre-save Link"
            iconPosition="right"
            iconSize="1.6"
            onClick={() => {
              window.open(`${window.location.origin}/${slug}`, "_blank");
            }}
            m_iconButton={true}
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M9.33399 8C9.33399 10.2091 7.54312 12 5.33398 12C3.12484 12 1.33398 10.2091 1.33398 8C1.33398 5.79086 3.12484 4 5.33398 4"
                  stroke="#FEA101"
                  stroke-linecap="round"
                />
                <path
                  d="M6.66602 8C6.66602 5.79086 8.45688 4 10.666 4C12.8751 4 14.666 5.79086 14.666 8C14.666 10.2091 12.8751 12 10.666 12"
                  stroke="#FEA101"
                  stroke-linecap="round"
                />
              </svg>
            }
          />
        </LinkBtn>
      </ItemContainer>
    );
  };

  return (
    <Main>
      {data?.map((item, index) => (
        <MusicItem key={index} {...item} />
      ))}
    </Main>
  );
};

export default MusicView;

const Main = styled.div`
  border-radius: 0.8rem;
  overflow-y: scroll;
`;

const ItemContainer = styled.div`
  width: 100%;
  padding: 1.2rem;
  display: flex;
  align-items: center;
  &:nth-child(odd) {
    background-color: ${Colors.grey700};
  }
  @media only screen and (max-width: 769px) {
    padding: 0.8rem;
  }
`;

const CoverImage = styled.img`
  width: 8.7rem;
  height: 8.7rem;
  border-radius: 6px;
  margin-right: 1.6rem;
  object-fit: contain;
  @media only screen and (max-width: 769px) {
    width: 6.4rem;
    height: 6.4rem;
  }
`;

const ItemTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 8.7rem;
  @media only screen and (max-width: 769px) {
    height: 6.4rem;
  }
`;

const FlexContainer = styled.div`
  width: fit-content;
  display: flex;
  align-items: center;
`;

const CopyButton = styled.div`
  background-color: ${Colors.grey600};
  width: 1.8rem;
  height: 1.8rem;
  display: flex;
  align-items: center;
  margin-left: 1rem;
  border-radius: 0.3rem;
  padding: 0.1rem;
  cursor: pointer;
`;

const LinkBtn = styled.div`
  margin-left: auto;
  margin-bottom: auto;
`;
